import { render, staticRenderFns } from "./sjjy2.vue?vue&type=template&id=114d40a0&scoped=true&"
import script from "./sjjy2.vue?vue&type=script&lang=js&"
export * from "./sjjy2.vue?vue&type=script&lang=js&"
import style0 from "./sjjy2.vue?vue&type=style&index=0&id=114d40a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114d40a0",
  null
  
)

export default component.exports